import { AuthRequired } from '@/shared/components/AuthRequired';
import React from 'react';

export const AccessDeniedPage: React.FC = () => (
  <AuthRequired
    title="Access Denied"
    message="You do not have permission to access this section."
  />
);
